var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "review",
    on: {
      "click": function ($event) {
        return _vm.emit('click');
      }
    }
  }, [_c('div', {
    staticClass: "review__complain",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.emit('report', {
          active: true,
          name: 'отзыв'
        });
      }
    }
  }, [_c('div', {
    staticClass: "icon-warning"
  })]), _vm._v(" "), _c('div', {
    staticClass: "review__content"
  }, [_c('div', {
    staticClass: "review__user"
  }, [_vm.review.name ? _c('ColorAvatar', {
    staticClass: "review__avatar",
    attrs: {
      "name": _vm.review.name,
      "size": "40"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "review__info"
  }, [_vm.review.name ? _c('div', {
    staticClass: "review__title-user"
  }, [_vm._v("\n          " + _vm._s(_vm.review.name) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm.review.date ? _c('div', {
    staticClass: "review__date-user"
  }, [_vm._v("\n          " + _vm._s(_vm.review.date) + "\n        ")]) : _vm._e()])], 1), _vm._v(" "), _vm.review.rate ? _c('div', {
    staticClass: "review__rating-wrap"
  }, [_c('TSProductRating', {
    attrs: {
      "is-active": _vm.review.rate,
      "show-status": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.review.advantage ? _c('div', {
    staticClass: "review__text-block"
  }, [_c('div', {
    staticClass: "review__title"
  }, [_vm._v("\n        Достоинства\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("\n        " + _vm._s(_vm.review.advantage) + "\n      ")])]) : _vm._e(), _vm._v(" "), _vm.review.limitation ? _c('div', {
    staticClass: "review__text-block"
  }, [_c('div', {
    staticClass: "review__title"
  }, [_vm._v("\n        Недостатки\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("\n        " + _vm._s(_vm.review.limitation) + "\n      ")])]) : _vm._e(), _vm._v(" "), _vm.review.text ? _c('div', {
    staticClass: "review__text-block"
  }, [_vm.review.advantage || _vm.review.limitation ? _c('div', {
    staticClass: "review__title"
  }, [_vm._v("\n        Комментарии\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("\n        " + _vm._s(_vm.review.text) + "\n      ")])]) : _vm._e(), _vm._v(" "), _vm.review.image && _vm.review.image.length ? _c('div', {
    staticClass: "review__attached-photo",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ReviewPhotoRow', {
    staticClass: "mt-10",
    attrs: {
      "images": _vm.review.image
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('Toggle', {
    attrs: {
      "initial-value": _vm.activeField
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$review$comment, _vm$review$comment2, _vm$review$like, _vm$review$like2, _vm$review$dislike, _vm$review$dislike2;

        var onClickToggle = _ref.onClick,
            isActive = _ref.isActive;
        return [!isActive ? _c('div', {
          staticClass: "review__footer"
        }, [_c('div', {
          staticClass: "review__footer-el review__footer-el_response",
          attrs: {
            "data-e2e": "review-comment-button"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.onClickAnswer({
                click: onClickToggle
              });
            }
          }
        }, [_c('div', {
          staticClass: "review__footer-button-wrap"
        }, [_vm.showCommentIcon && (_vm$review$comment = _vm.review.comment) !== null && _vm$review$comment !== void 0 && _vm$review$comment.length ? [_c('div', {
          staticClass: "icon-comment review__footer-icon-comment"
        }), _vm._v(" "), _c('span', {
          staticClass: "review__footer-comment-count"
        }, [_vm._v(_vm._s((_vm$review$comment2 = _vm.review.comment) === null || _vm$review$comment2 === void 0 ? void 0 : _vm$review$comment2.length))])] : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "review__footer-comment-button"
        }, [_vm._v("\n            Ответить\n          ")])], 2)]), _vm._v(" "), _c('div', {
          staticClass: "review__footer-el",
          attrs: {
            "data-e2e": "review-positive"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.onClickPositive.apply(null, arguments);
            }
          }
        }, [_c('div', {
          staticClass: "review__positive",
          class: [{
            'review__positive_is-active': (_vm$review$like = _vm.review.like) === null || _vm$review$like === void 0 ? void 0 : _vm$review$like.active
          }]
        }, [_vm._v("\n          " + _vm._s((_vm$review$like2 = _vm.review.like) === null || _vm$review$like2 === void 0 ? void 0 : _vm$review$like2.count) + "\n        ")])]), _vm._v(" "), _c('div', {
          staticClass: "review__footer-el",
          attrs: {
            "data-e2e": "review-negative"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.onClickNegative.apply(null, arguments);
            }
          }
        }, [_c('div', {
          staticClass: "review__negative",
          class: [{
            'review__negative_is-active': (_vm$review$dislike = _vm.review.dislike) === null || _vm$review$dislike === void 0 ? void 0 : _vm$review$dislike.active
          }]
        }, [_vm._v("\n          " + _vm._s((_vm$review$dislike2 = _vm.review.dislike) === null || _vm$review$dislike2 === void 0 ? void 0 : _vm$review$dislike2.count) + "\n        ")])])]) : _vm._e(), _vm._v(" "), isActive ? _c('div', {
          staticClass: "review__response-form"
        }, [_vm._t("default", null, {
          "data": _vm.review,
          "toggleShow": onClickToggle
        })], 2) : _vm._e()];
      }
    }], null, true)
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }